import React, {Component} from 'react';
import {EventClient} from "../../util/eventClient";

class SidebarMinimizer extends Component {

  componentDidMount() {
    EventClient.on("NAV_MINIMIZE", () => this.forceMinimize(), "SidebarMinimizer");
  }

  componentWillUnmount() {
    EventClient.off("NAV_MINIMIZE", () => this.forceMinimize(), "SidebarMinimizer");
  }

  sidebarMinimize() {
    document.body.classList.toggle('sidebar-minimized');
  }

  brandMinimize() {
    document.body.classList.toggle('brand-minimized');
  }

  forceMinimize() {
    if (!document.body.classList.contains("sidebar-minimized") && !document.body.classList.contains("sidebar-minimized")) {
      this.sidebarMinimize();
      this.brandMinimize();
    }
  }

  render() {
    return (
      <button className="sidebar-minimizer" type="button" onClick={(event) => {
        this.sidebarMinimize();
        this.brandMinimize()
      }}></button>
    )
  }
}

export default SidebarMinimizer;



// WEBPACK FOOTER //
// ./src/components/SidebarMinimizer/SidebarMinimizer.js